// Detect xem model name có phải reasoning model không (cần strip temperature, dùng
// max_completion_tokens thay max_tokens).
//
// Background:
//   - Reasoning models (Anthropic Claude 4+ extended thinking, OpenAI o-series)
//     KHÔNG accept `temperature` param → API 400 invalid_request_error.
//   - GitNexus có flag --reasoning-model strip param này. Avatar cần auto-pass khi
//     detect model thuộc nhóm reasoning.
//   - Code khác Avatar call LLM (vd avatar ai test /v1/messages) cũng cần biết để
//     skip temperature param.
//
// Pattern match (theo Anthropic + OpenAI docs):
//   - Anthropic: claude-opus-4-*, claude-sonnet-4-* (thinking từ Claude 4)
//                LLMLite alias mapping: nal-claude-opus-* nếu user map tới opus-4
//   - OpenAI:    o1, o1-mini, o1-preview, o3, o3-mini, o4-mini
//
// Maintainable: thêm pattern vào REASONING_PATTERNS array khi Anthropic/OpenAI ship
// model mới với reasoning.

// Regex patterns — case-insensitive match. Order không quan trọng (any match → true).
const REASONING_PATTERNS: RegExp[] = [
  // Anthropic Claude 4+ với extended thinking.
  // Match: claude-opus-4-7, claude-opus-4-8, claude-sonnet-4-5, claude-opus-4-1, ...
  /^claude-(opus|sonnet)-4/i,

  // Anthropic Claude 5+ (future-proof — assume reasoning theo trend).
  /^claude-(opus|sonnet|haiku)-[5-9]/i,

  // OpenAI o-series (o1, o3, o4).
  /^o1(-|$)/i,
  /^o3(-|$)/i,
  /^o4(-|$)/i,

  // LLMLite NAL alias mapping — phổ biến nal-claude-opus-* trỏ tới opus-4+.
  // (Conservative: chỉ match nếu name có chứa opus/sonnet + version số.)
  /nal-claude-(opus|sonnet)-?4/i,
];

// Main entry. Trả true nếu model name khớp 1 pattern reasoning.
// Empty string / null → false (an toàn — fallback model thường dùng temperature OK).
export function isReasoningModel(modelName: string | null | undefined): boolean {
  if (!modelName) return false;
  return REASONING_PATTERNS.some((pattern) => pattern.test(modelName));
}
